import { Course } from '@yandex-int/k-common/typings';
import cx from 'classnames';
import { Select, Text } from 'platform-components';
import { SELECT_THEMES } from 'platform-components/constants';
import { SelectEvent } from 'platform-components/src/typings';
import React from 'react';

import './course-year-filter.scss';

interface Props {
    courseId: number;
    courses: Array<Course>;
    mix?: string;
    onSelectCourse: (option: SelectEvent<number>) => void;
}

export const CourseYearFilter = ({ courses, courseId, mix, onSelectCourse }: Props) => {
    if (!courses || !courses.length) {
        return null;
    }

    const selectedCourseOrDefaultId = courses.some(({ id }) => id === courseId) ? courseId : courses[0].id;

    return (
        <div className={cx('course-year-filter', mix)}>
            <Text id="courseJournal.year" weight={Text.WEIGHT.M} />
            <Select
                mix="course-year-filter__select"
                onSelect={onSelectCourse}
                theme={SELECT_THEMES.CLEAN}
                value={selectedCourseOrDefaultId}
                width="136px"
            >
                {courses.map(({ id, year }) => (
                    <Select.Option key={id} value={id}>
                        <Text>{year}</Text>
                    </Select.Option>
                ))}
            </Select>
        </div>
    );
};

export default CourseYearFilter;
